/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';



/**
 * Fonctions de ping
 */
@Injectable({
  providedIn: 'root',
})
export class PingService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation pingPing
   */
  static readonly PingPingPath = '/api/ping/ping';

  /**
   * Renvoie Pong.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pingPing()` instead.
   *
   * This method doesn't expect any request body.
   */
  pingPing$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, PingService.PingPingPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Renvoie Pong.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pingPing$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pingPing(params?: {
  }): Observable<string> {

    return this.pingPing$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation pingPingAuth
   */
  static readonly PingPingAuthPath = '/api/ping/ping-auth';

  /**
   * Renvoie Pong (nécessite d'être authentifié).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pingPingAuth()` instead.
   *
   * This method doesn't expect any request body.
   */
  pingPingAuth$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, PingService.PingPingAuthPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Renvoie Pong (nécessite d'être authentifié).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pingPingAuth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pingPingAuth(params?: {
  }): Observable<string> {

    return this.pingPingAuth$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
